/* eslint-disable import/no-cycle */
import validators from './defaultValidators';
import { cloneObject } from '.';

function validateForm(dataForm) {
    const validatedForm = cloneObject(dataForm);
    const defaultRequiredMessage = 'Preencha com um valor válido';
    const invalidsFields = [];

    let isValid = true;

    // Limpa as mensagens de erro do formulario
    Object.keys(validatedForm).forEach((field) => {
        // Remove os espacos iniciais e finais dos textos
        if (validatedForm[field].type === 'text') {
            validatedForm[field].value = validatedForm[field].value && validatedForm[field].value.toString().trim();
        }

        delete validatedForm[field].error;

        if (validatedForm[field].disabled) return;

        if (validatedForm[field].required || (!validatedForm[field].required && !!validatedForm[field].value)) {
            if (typeof validators[field] === 'function') {
                validators[field](validatedForm);
            }
        }

        // Valida os campos obrigatorios vazios
        // Necessario validar se o valor é um array para caso do datepicker Range. Entao temos que verificar se é um array e se esse array tem posicoes

        // 1 - SE campo obrigatorio E ( esta em vazio OU é um array sem posicoes )
        if (
            validatedForm[field].required &&
            (!validatedForm[field].value ||
                (Array.isArray(validatedForm[field].value) && !validatedForm[field].value?.length))
        ) {
            validatedForm[field].error = validatedForm[field].requiredMessage || defaultRequiredMessage;
        }

        // Verifica se tem algum campo com mensagem de erro
        if (validatedForm[field].error) {
            isValid = false;
            invalidsFields.push(validatedForm[field]);
        }
    });

    return {
        validatedForm,
        isValid,
        invalidsFields,
    };
}

export default validateForm;
